import currentBrand from '@/brands';

export const brandKey = currentBrand.key;
export const appName = currentBrand.appName;
export const appSortName = currentBrand.appSortName;
export const themeColor = currentBrand.themeColor;
export const mainDescription = currentBrand.mainDescription;
export const mainKeywords = currentBrand.mainKeywords;
export const shareImage = currentBrand.shareImage;
export const packageId = currentBrand.packageId as number;
export const packageInfo = currentBrand.packageInfo;
export const defaultChannel = currentBrand.defaultChannel;
export const disabledPhoneCode = currentBrand.disabledPhoneCode;
export const apiSendPhoneCode = currentBrand.apiSendPhoneCode;
export const defaultPhoneCode = currentBrand.defaultPhoneCode;
export const homePage = currentBrand.homePage;
export const defaultApkPath = currentBrand.defaultApkPath;
export const defaultApkName = currentBrand.defaultApkName;
export const defaultApkPrefix = currentBrand.defaultApkPrefix;
export const gameNavigateVersion = currentBrand.gameNavigateVersion;
export const linkingPrefixes = currentBrand.linkingPrefixes;
